import { render } from "./GeographySelector.vue?vue&type=template&id=4d67b738&scoped=true"
import script from "./GeographySelector.vue?vue&type=script&lang=js"
export * from "./GeographySelector.vue?vue&type=script&lang=js"

import "./GeographySelector.vue?vue&type=style&index=0&id=4d67b738&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d67b738"]])

export default __exports__